import { css } from "@/../styled-system/css";
import Skeleton from "@/components/ui/Skeleton";

const customHitsContainerClass = css({
  position: "absolute",
  backgroundColor: "white",
  zIndex: "2",
  left: "0",
  right: "0",
  bottom: "0",
  width: "100%",
  overflow: "auto",
  top: "164px",
  sm: {
    top: "96px",
  },
});

const searchProductGridClass = css({
  display: "grid",
  gridGap: "2",
  justifyContent: "space-between",
  xs: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  sm: {
    gridTemplateColumns: "repeat(3, 1fr)",
    gridGap: "4",
  },
  md: {
    gridTemplateColumns: "repeat(4, 1fr)",
    gridGap: "6",
  },
  xl: {
    gridTemplateColumns: "repeat(5, 1fr)",
    gridGap: "6",
  },
});

function CustomHitsSkeleton() {
  const card_count = 12;
  const cards = Array.from(Array(card_count).keys());
  return (
    <div className={customHitsContainerClass}>
      <div className={css({ pb: "5" })}>
        <div
          className={css({
            maxWidth: "1628px",
            width: "90%",
            margin: "0 auto",
          })}
        >
          <div className={searchProductGridClass}>
            {cards.map((_, index) => (
              <Skeleton
                key={index}
                css={{ width: "100%", aspectRatio: "0.65" }}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomHitsSkeleton;
